export const SORT_BY_TYPES = {
  'Popular': 'Popular',
  'Price Low to High': 'Price Low to High',
  'Price High to Low': 'Price High to Low',
  'Top Rated First': 'Top Rated First',
};
